import { init, withScope, captureException } from '@sentry/react';
import env from '@frontend/env';
import { SentryTeamNames } from '@frontend/sentry-teams';
import { getSentryConfig } from '@frontend/tracking';

const initialize = () => {
  // IMPORTANT: env.IS_PREVIEW reads from the notification-specific env var, not the generic VITE_IS_PREVIEW.
  let environment: 'test' | 'preview' | 'production' = 'test';
  if (env.IS_PREVIEW === 'true') {
    environment = 'preview';
  } else if (import.meta.env.MODE === 'production') {
    environment = 'production';
  }

  return init(
    getSentryConfig({
      // IMPORTANT: These env vars must match what is set in reusable-build-and-deploy.yml
      dsn: env.SENTRY_DSN,
      release: env.VERSION,
      environment,
      disableTransport: true,
      disableReplay: true,
      // notification has no third-party integrations or replay
      integrations: [],
      // notification relies only on sampleRate for error filtering — no manual beforeSend sampling
      beforeSend: (event: any) => event,
      beforeBreadcrumb: (bc: any) => bc,
      beforeSendSpan: (span: any) => span,
    })
  );
};

export const error = ({
  error,
  topic,
  team,
  severityLevel = 'error',
  addContext,
}: {
  error: unknown;
  topic: string;
  team: SentryTeamNames;
  severityLevel: 'error';
  addContext?: {
    name: string;
    context: Record<string, any>;
  };
}) => {
  withScope((scope) => {
    scope.setTag('topic', topic);
    scope.setTag('team', team);
    scope.setLevel(severityLevel);
    if (!!addContext) scope.setContext(addContext.name, addContext.context);
    captureException(error);
  });
};

const sentry: {
  initialize: () => ReturnType<typeof init>;
  error: typeof error;
} = {
  initialize,
  error,
};

export { sentry };
